(() => {
'use strict';
const product = window.previewProduct;
const config = window.storefrontCommerce;
if (!config || !product) return;
const root = config.root.endsWith('/') ? config.root : config.root + '/';
const cart = document.querySelector('#cart');
const info = document.querySelector('#info');
const form = document.querySelector('#purchase-form');
const buyButtons = [...document.querySelectorAll('.add-cart')];
let busy = false;
let selected = config.variants.find(v => v.id === config.selected) || config.variants.find(v => v.available) || config.variants[0];
const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const money = (cents, currency = config.currency) => new Intl.NumberFormat('en-NZ', {style:'currency',currency}).format(cents / 100);
function showInfo(title, body) {
 document.querySelector('#info-title').textContent = title;
 document.querySelector('#info-body').textContent = body;
 if (cart.open) cart.close();
 if (!info.open) info.showModal();
}
async function request(path, body) {
 const response = await fetch(root + path, {
  method: body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store',
  headers: {'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})},
  ...(body ? {body:JSON.stringify(body)} : {})
 });
 const data = await response.json();
 if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Your bag could not be updated. Please try again.');
 return data;
}
function setBusy(value) {
 busy = value;
 buyButtons.forEach(b => {b.disabled = value || !selected?.available;b.setAttribute('aria-busy',String(value));});
 document.querySelectorAll('#cart button[data-remove],#cart button[data-quantity]').forEach(b => b.disabled = value);
 const checkout = document.querySelector('#cart [data-checkout]');
 if (checkout) {checkout.setAttribute('aria-disabled',String(value));checkout.tabIndex = value ? -1 : 0;}
}
function renderCart(data) {
 document.querySelector('[data-count]').textContent = data.item_count;
 document.querySelector('[data-open-cart]').setAttribute('aria-label',`Open cart, ${data.item_count} items`);
 const host = document.querySelector('#cart-content');
 if (!data.items.length) {
  host.innerHTML = '<p class="empty">Your bag is empty.</p><button type="button" class="cta" data-continue>CONTINUE SHOPPING</button>';
  host.querySelector('[data-continue]').onclick = () => cart.close();
  return;
 }
 host.innerHTML = data.items.map(item => `<div class="cart-item">${item.image ? `<img class="cart-item-photo" src="${escape(item.image)}" alt="${escape(item.product_title)}" width="88" height="88">` : ''}<a href="${escape(item.url)}"><b>${escape(item.product_title)}</b></a>${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escape(item.variant_title)}</span>` : ''}<div class="cart-quantity"><button type="button" data-quantity="${item.quantity-1}" data-key="${escape(item.key)}" aria-label="Decrease quantity of ${escape(item.title || item.product_title)}">−</button><span>Quantity: ${item.quantity}</span><button type="button" data-quantity="${item.quantity+1}" data-key="${escape(item.key)}" aria-label="Increase quantity of ${escape(item.title || item.product_title)}">+</button></div><strong>${money(item.final_line_price,data.currency)} ${escape(data.currency)}</strong><button type="button" data-remove data-key="${escape(item.key)}">Remove</button></div>`).join('') +
  `<div class="cart-total"><span>Subtotal</span><span>${money(data.total_price,data.currency)} ${escape(data.currency)}</span></div><p class="cart-shipping">Free standard shipping in NZ and Australia. Taxes and delivery options are confirmed at checkout.</p><a class="cta" data-checkout href="${root}checkout">CHECK OUT →</a>`;
 host.querySelectorAll('[data-remove],[data-quantity]').forEach(b => b.onclick = () => changeLine(b.dataset.key, b.hasAttribute('data-remove') ? 0 : Number(b.dataset.quantity)));
 host.querySelector('[data-checkout]').onclick = e => {if (busy) e.preventDefault();};
}
async function refreshCart() {const data = await request('cart.js');renderCart(data);return data;}
async function changeLine(key, quantity) {
 if (busy) return;
 setBusy(true);
 try {renderCart(await request('cart/change.js',{id:key,quantity}));}
 catch(error) {showInfo('Unable to update your bag',error.message);}
 finally {setBusy(false);}
}
async function addToCart(event) {
 event?.preventDefault();
 if (busy || !selected?.available) return;
 setBusy(true);
 let added = false;
 try {
  await request('cart/add.js',{items:[{id:selected.id,quantity:1}]});
  added = true;
  await refreshCart();
  if (!cart.open) cart.showModal();
 } catch(error) {
  if (added) window.location.assign(root + 'cart');
  else showInfo('Unable to add to your bag',error.message);
 } finally {setBusy(false);}
}
function selectVariant(variant, units, updateURL = false) {
 if (!variant) return;
 selected = variant;
 document.querySelectorAll('[data-price]').forEach(el => el.textContent = money(variant.price));
 const compareAt = variant.compare_at_price || (units === 2 ? product.pairwas : product.was) * 100;
 document.querySelectorAll('[data-was]').forEach(el => el.textContent = money(compareAt));
 document.querySelectorAll('[data-discount-percent]').forEach(el => {
  el.textContent = (compareAt > variant.price ? Math.round((compareAt - variant.price) * 100 / compareAt) : 0) + '%';
 });
 if (form) {
  form.elements.id.value = variant.id;
  form.elements.id.dispatchEvent(new Event('change',{bubbles:true}));
 }
 buyButtons.forEach(b => {
  b.disabled = busy || !variant.available;
  b.innerHTML = variant.available ? 'ADD TO CART <span>→</span>' : 'SOLD OUT';
 });
 if (updateURL) {const url = new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);}
}
document.querySelectorAll('[name="bundle"]').forEach(input => {
 const units = Number(input.value);
 const variant = config.variants.find(v => String(v.id) === input.dataset.variantId) || config.variants.find(v => v.title.startsWith(String(units)+' '));
 input.disabled = !variant?.available;
 if (variant) {const price = input.closest('label').querySelector('[data-bundle-price]');if (price) price.textContent = money(variant.price);}
 input.checked = variant?.id === selected?.id;
 input.addEventListener('change',() => selectVariant(variant,units,true));
});
selectVariant(selected, selected?.title.startsWith('2 ') ? 2 : 1);
buyButtons.forEach(button => button.addEventListener('click',addToCart));
form?.addEventListener('submit',addToCart);
document.querySelector('[data-open-cart]').addEventListener('click',async() => {
 if (busy) return;
 try {await refreshCart();if (!cart.open) cart.showModal();}
 catch(error) {showInfo('Unable to load your bag',error.message);}
});
document.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click',() => b.closest('dialog').close()));
document.querySelectorAll('.thumb').forEach(button => button.addEventListener('click',() => {
 const mainPhoto = document.querySelector('.gallery-main');
 mainPhoto.src = button.dataset.src;
 const thumbPhoto = button.querySelector('img');
 mainPhoto.width = thumbPhoto.naturalWidth || 1024; mainPhoto.height = thumbPhoto.naturalHeight || 1024;
 document.querySelector('.gallery-main').alt = button.dataset.alt;
 document.querySelectorAll('.thumb').forEach(b => {b.classList.toggle('selected',b === button);b.setAttribute('aria-pressed',String(b === button));});
}));
document.querySelectorAll('[data-info]').forEach(a => a.addEventListener('click',e => {e.preventDefault();showInfo(a.dataset.info,a.dataset.info === 'Shipping policy' ? 'Free shipping in NZ and Australia. For shipping enquiries, contact support@'+product.brand.toLowerCase()+'.com.' : 'For '+a.dataset.info.toLowerCase()+' enquiries, contact support@'+product.brand.toLowerCase()+'.com.');}));
document.querySelectorAll('.mobile-menu a').forEach(a => a.addEventListener('click',() => a.closest('details').open = false));
let reviewIndex = 0;
function cycleReview(direction) {reviewIndex = (reviewIndex + direction + product.reviews.length) % product.reviews.length;document.querySelector('[data-quote]').textContent = product.reviews[reviewIndex][2];document.querySelector('[data-reviewer]').textContent = product.reviews[reviewIndex][0];document.querySelector('[data-review-index]').textContent = (reviewIndex+1)+' / '+product.reviews.length;}
document.querySelector('[data-prev-review]').onclick = () => cycleReview(-1);
document.querySelector('[data-next-review]').onclick = () => cycleReview(1);

document.querySelectorAll('.comparison-wrap').forEach(wrap => {
 const demo = wrap.querySelector('.comparison-demo');
 const range = wrap.querySelector('.comparison-range');
 const updateComparison = () => {
  const value = Math.max(0,Math.min(100,Number(range.value)));
  demo.style.setProperty('--reveal',value+'%');
  range.setAttribute('aria-valuetext',`${value}% ${demo.dataset.beforeLabel}, ${100-value}% ${demo.dataset.afterLabel}`);
 };
 range.addEventListener('input',updateComparison);
 wrap.querySelectorAll('[data-comparison-position]').forEach(button => button.addEventListener('click',() => {
  range.value = button.dataset.comparisonPosition;
  updateComparison();
 }));
 updateComparison();
});
window.addEventListener('pageshow' ,() => refreshCart().catch(() => {}));
refreshCart().catch(() => {});
})();
